import { UsercentricsConsent } from './UsercentricsConsent'

export default UsercentricsConsent
